import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/** KPI/stat tile (mockup `.stat` with `.n` number + `.l` label). */
@Component({
  selector: 'app-stat',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stat.component.html',
  styleUrl: './stat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatComponent {
  @Input() value: string | number = '';
  @Input() label = '';
  /** CSS color for the number (e.g. var(--teal-deep)). */
  @Input() valueColor?: string;
  @Input() clickable = false;

  @Output() clicked = new EventEmitter<void>();
}
